import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { RouterModule } from '@angular/router';

import { AddToCalendarDialogModule } from '@libs/src/add-to-calendar-dialog/add-to-calendar-dialog.module';
import { EventSignUpSubmissionSuccessToastModule } from '@main-client/src/app/event-sign-up-submission-success-toast/event-sign-up-submission-success-toast.module';
import { EventParticipantsModule } from '@main-client/src/app/events/event-participants/event-participants.module';
import { EventUpdatedSubmissionsDialogModule } from '@main-client/src/app/events/event-updated-submissions-dialog/event-updated-submissions-dialog.module';
import { FeedItemAccountInfoModule } from '@main-client/src/app/feed/feed-item-account-info/feed-item-account-info.module';
import { FeedItemEventDateModule } from '@main-client/src/app/feed/feed-item-event/feed-item-event-date/feed-item-event-date.module';
import { FeedItemEventMeetingMethodModule } from '@main-client/src/app/feed/feed-item-event/feed-item-event-meeting-method/feed-item-event-meeting-method.module';
import { AccountExperiencePipeModule } from '@main-client/src/app/pipes/account-experience-pipe/account-experience-pipe.module';
import { AccountFullNamePipeModule } from '@main-client/src/app/pipes/account-full-name-pipe/account-full-name-pipe.module';
import { IsAdminOfGroupPipeModule } from '@main-client/src/app/pipes/is-admin-of-group-pipe/is-admin-of-group-pipe.module';
import { IsFeaturedAccountPipeModule } from '@main-client/src/app/pipes/is-featured-account-pipe/is-featured-account-pipe.module';
import { PermittedEventLocationPipeModule } from '@main-client/src/app/pipes/permitted-event-location-pipe/permitted-event-location-pipe.module';
import { ToFeedItemEventModule } from '@main-client/src/app/pipes/to-feed-item-event-pipe/to-feed-item-event.module';

import { EventBodyComponent } from './event-body.component';

@NgModule({
  imports: [
    AddToCalendarDialogModule,
    AccountFullNamePipeModule,
    AccountExperiencePipeModule,
    CommonModule,
    EventParticipantsModule,
    EventSignUpSubmissionSuccessToastModule,
    EventUpdatedSubmissionsDialogModule,
    FeedItemAccountInfoModule,
    FeedItemEventDateModule,
    FeedItemEventMeetingMethodModule,
    FlexLayoutModule,
    IsAdminOfGroupPipeModule,
    IsFeaturedAccountPipeModule,
    MatButtonModule,
    MatDialogModule,
    MatIconModule,
    MatMenuModule,
    MatSnackBarModule,
    PermittedEventLocationPipeModule,
    RouterModule,
    ToFeedItemEventModule,
  ],
  declarations: [EventBodyComponent],
  exports: [EventBodyComponent],
})
export class EventBodyModule {}
